export const SET_INITIAL_PAGE = "SET_INITIAL_PAGE";
export const SET_RESPONSIVE_DATA = "SET_RESPONSIVE_DATA";
